import { Grid, IconButton, Tooltip } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import Edicao from './Edicao'
import ModalProcessaPagamento from './ModalProcessaPagamento'
import { useModal } from '../../../components/Utils/UseModal'
import { GiMoneyStack } from 'react-icons/gi'

const GestaoDeComissoes = () => {
  const { localAtendimento } = useContext(GlobalContext)
  const openModal = useModal(ModalProcessaPagamento)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const abreProcessaPagamento = async () => {
    await openModal({ pagamento: true })
  }

  const voltar = () => {
    setTela('lista')
    setDados([])
    setRefresh((prev) => prev + 1)
  }

  const handleClick = (value) => {
    setDados(value)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Processar Pagamento">
            <IconButton onClick={abreProcessaPagamento}>
              <GiMoneyStack />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlPagamentoComissao" ferramentas={ferramentas}>
      {tela === 'opcoes' ? (
        <Edicao {...{ dados, voltar, setTela }} />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid item xs={12}>
              {localAtendimento && (
                <PrimeTable
                  codigo="CtrlPagamentoComissao"
                  action="lista"
                  rows={10}
                  habSearch
                  head={[
                    'Vendedor',
                    'Inicial',
                    'Final',
                    'Total Venda',
                    'Total Comissão',
                    'Pago em',
                    'Valor Pago',
                  ]}
                  line={(item) => [
                    item[1][1],
                    item[3],
                    item[4],
                    item[5],
                    item[6],
                    item[8],
                    item[9],
                  ]}
                  collumnsCurrency={[3, 4, 6]}
                  collumnsDate={[1, 2, 5]}
                  parametros={{ idLocalAtendimento: localAtendimento[0] }}
                  onRowSelect={handleClick}
                  refresh={refresh}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Programa>
  )
}

export default GestaoDeComissoes
